export const DASHBOARD_HERO_PARTICLES: Array<{
  tone: 'gold' | 'white' | 'ice';
  top: string;
  left: string;
  width: number;
  height: number;
  delay: string;
  duration: string;
}> = [
  { tone: 'gold', top: '16%', left: '6%', width: 5, height: 5, delay: '0s', duration: '7s' },
  { tone: 'white', top: '30%', left: '20%', width: 3, height: 3, delay: '1.6s', duration: '9s' },
  { tone: 'gold', top: '70%', left: '10%', width: 4, height: 4, delay: '2.4s', duration: '8s' },
  { tone: 'ice', top: '48%', left: '34%', width: 3, height: 3, delay: '.9s', duration: '10s' },
  { tone: 'gold', top: '82%', left: '24%', width: 5, height: 5, delay: '3.8s', duration: '7.5s' },
  { tone: 'white', top: '20%', left: '54%', width: 3, height: 3, delay: '1.9s', duration: '11s' },
  { tone: 'gold', top: '58%', left: '48%', width: 4, height: 4, delay: '4.5s', duration: '8.5s' },
  { tone: 'ice', top: '36%', left: '66%', width: 3, height: 3, delay: '1.2s', duration: '9.5s' },
  { tone: 'gold', top: '76%', left: '62%', width: 5, height: 5, delay: '3.3s', duration: '7s' },
  { tone: 'white', top: '10%', left: '76%', width: 3, height: 3, delay: '.6s', duration: '10.5s' },
  { tone: 'gold', top: '90%', left: '74%', width: 4, height: 4, delay: '2.8s', duration: '8s' },
];
